import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as enums from '../enums'

import { Api } from './api.service'
import type { TypeParams } from './types'

/** @see {@link ec.Collection} */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const enumsEc = ngCore.inject(enums.Collection)

    super({
      api: ngCore.inject(Api),
      context$: enumsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asObservable.pipe(rxjs.map(currentEnum => currentEnum?.entries)),
      identify: entity => entity.id,
      name: ec.Name.Predefined.DmsEnumEntry,
      plugins: {
        additionalFactories: [new ds.table.ec.Factory()],
        currentList: {
          sortBy: { get: () => 'name' },
        },
      },
    })
  }
}
